"use client";
import {
  link_default
} from "../../chunk-JSVC6WBO.js";
export {
  link_default as default
};
